module.exports = __webpack_public_path__ + "media/images/staff-pic-9bca3cc79e75a9c875b4eb57b6a133c8.svg";